import appConfig from '@/config'

const commonActions={
    SAVE_SUCCESS: "SAVE-SUCCESS",
    CANCEL_ACTION: "CANCEL-ACTION",
    SET_BASE_STATE : 'SET_BASE_STATE', // 设置根State信息
}



export const appConst= {
    localization:{
        defaultLocalizationSourceName: 'Common'
    },
    authorization:{
        encrptedAuthTokenName: 'enc_auth_token'
    },

    uploadUrl: {
        postAction: "fileuploader/uploader",
        previewAction: "fileuploader/view",
        deleteAction: "fileuploader/delete",
        exportAction:'fileUpload/exportExcel'
    },

    appBaseUrl: appConfig.baseUrl,
    remoteServiceBaseUrl: appConfig.baseUrl.endsWith('/') ? appConfig.baseUrl.slice(0, -1) : appConfig.baseUrl,

    commonActions:commonActions,


    codeCategory:{
        declareCustomsStatus:'DeclareCustomsStatus',
        shippingType:'ShippingType',
        businessGroup:'BusinessGroup',
        startPort:'StartPort',
        transaction:'Transaction',
        endPort:'EndPort',
        countryOfArrival:'CountryOfArrival',
        tradingCountry:'TradingCountry',
        payment:'Payment',
        salesType:'SalesType',
        boxType:'BoxType',
        unit:'Unit',
        yesOrNo:'YesOrNo',
        domesticSourceOfGood:'DomesticSourceOfGood',
        currency:'Currency',
        confirmStatus:"ConfirmStatus",
        category:"Category",
        incomeStatus: "IncomeStatus",
        incomeType: "IncomeType",
        profitType: "ProfitType",
        billOfLadingUploadStatus: "BillOfLadingUploadStatus",
        regulatoryApproach: "RegulatoryApproach"
    },
    confirmStatus:{
        toBeConfirmed: "ToBeConfirmed",//待确认 
        confirming:"Confirming",// 确认中
        confirmed: "Confirmed",// 已确认


    },
    declareCustomsStatus:{
        pending : "Pending",//待提交
        inProgress : "InProgress",// 进行中
        completed : "Completed"//以结算


    },
    objectiveDifficulty: {
        high: "High",
        middle: "Middle",
        low: "Low",
    },

    salesType: {
        domesticSales: "DomesticSales",
        exportSales: "ExportSales"
    },
    yesorNo: {
        yes: "Yes",
        no: "No"
    },

    // 币种
    currency: {
        RMB: "RMB",
        USD: "USD"
    },
    dateFormat: {
        year: "YYYY",
        month: "MM",
        monthContainYear: "MMM yyyy",
        datepickerYear: "yyyy",
        datepickerYearAndMonth: "yyyy-MM",
        date: "DD MMM YYYY",
        startOfDay: "YYYY-MM-DD 00:00:00"
    },

    incomeStatus: {
        notExpired: "NotExpired",
        overdue: "Overdue",
        received: "Received"
    },

    incomeType: {
        prepayment: "Prepayment",
        restAmount: "RestAmount"
    },
    unit: {
        size: "Size"
    },

    declareCustomsCreateType: {
        create: 1,
        copy: 2,
        import: 3
    }
}